import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

let reactPlugin: ReactPlugin = null;

/**
 * - Initializes react plugin for application insights
 * - NOTE: Only initialized once
 */
const initReactPlugin = () => {
  if (!reactPlugin) reactPlugin = new ReactPlugin();
  return reactPlugin;
};

const getReactPlugin = () => reactPlugin;

export { initReactPlugin, getReactPlugin };



// WEBPACK FOOTER //
// ./src/appInsights/utils/initReactPlugin.ts